import type { routes } from '@semios/app-platform-banyan-route-definitions'
import { serviceCenterStore } from 'App/ServiceCenter/store/serviceCenterStore'
import type { TActiveNode } from 'App/ServiceCenter/types'
import { cloneDeep } from 'lodash'
import { apiFetch } from 'utils/apiFetch'

export type NodeSwapMeta = routes.ServiceCenterNodeSwap.Request

export const request = async (param: NodeSwapMeta) => {
  await apiFetch({ url: '/service-center-node-swap', body: param })

  return param
}

export const callback = async (param: NodeSwapMeta) => {
  const activeNodes = serviceCenterStore.selectors.getAllActiveNodes(serviceCenterStore.getState())

  const swappedOutNode = activeNodes.find(
    (node) => (node as TActiveNode).nodeIdentifier === param.nodeIdentifierToRemove,
  ) as TActiveNode

  if (!swappedOutNode) return

  serviceCenterStore.actions.removeActiveNode(param.nodeIdentifierToRemove)

  const updatedNode = cloneDeep({
    ...swappedOutNode,
    nodeIdentifier: param.nodeIdentifierToInstall,
    name: param.newName || null,
  })

  serviceCenterStore.actions.updateActiveNode(updatedNode)
}

export const serviceCenterNodeSwap = {
  request,
  callback,
}
